import { BaseMessageInfo } from "./BaseMessageInfo";
import { DispatchBus } from "./DispatchBus";

export class DispatchMessageInfo extends BaseMessageInfo
{
    constructor(data: DispatchMessageInfo = null) {
        super(data);
    }
    dispatch: DispatchBus;
    statusChangeOk: boolean;
    askCompleteResources: boolean;
    underConstructionWarrantyFlag: boolean;
}
